import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import {AppMenuBarInfoContent} from "./AppMenuBarInfoContent";

export default function AppMenuBarInfoDialogue({open, onClose, selectorContractGridAPI
                                             }) {

    const handleCloseInfo = () => {
        onClose(true);
    };

    const info = AppMenuBarInfoContent(selectorContractGridAPI);

    return (
        <>

            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    {info.title}
                </DialogTitle>

                <DialogContent>
                    {info.content}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseInfo}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    );
}